module.exports = __webpack_public_path__ + "img/slogan.4306cbb0.png";